import { round } from 'lodash';
import React from 'react';
import { IChartCardLeftProps } from '.';

const FiverLeft: React.FC<IChartCardLeftProps> = ({ helper }) => (
  <p className="f1 display mv0">
    {round(
      helper.aggregate({
        aggregationType: 'average',
        seriesType: 'average'
      }),
      2
    ) || 0}
  </p>
);

export default FiverLeft;
